
import StatusChip from "./StatusChip"
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

export const GetStatusChip = (props: any) => {
    const row = props?.data
    const column = props?.column?.colId

    type status = null | "TrainingInProgress" | "TrainingComplete";
    type outputStatus = "notstarted" | "traininginprogress" | "completed"

    const renderState = (status: status): outputStatus => {
        switch (status) {
        case null:
            return "notstarted"
        case "TrainingInProgress":
            return "traininginprogress"
        case "TrainingComplete":
            return "completed"
        }
    }

    if(column === "ducStatus"){
        if (row?.isRemoved === true){
            return <StatusChip state ="revoked"/>
        }

        if(row?.isCancelled === true){
            return <StatusChip state ="cancelled"/>
        }else{
            return <StatusChip state= {props?.value.toLowerCase()}/>
        }
    }
    else {
        return <StatusChip state= {renderState(props.value)}/>
    }

}

export const GetRevoked = (props: any) => {
    const row = props?.data
    if(row?.isRemoved === true){
        return <DeleteForeverOutlinedIcon color="disabled"/>
    }
    if(row?.ducStatus === "Approved"){
        return <DeleteForeverOutlinedIcon/>
    }
    else{
        return <DeleteForeverOutlinedIcon color="disabled"/>
    }
}